import theme from "@/constants/theme";
import React from "react";

const styles: Record<string, React.CSSProperties> = {
  card: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    width: "100%",
    minHeight: 104,
    padding: '16px 16px',
    backgroundColor: "rgba(255, 255, 255, 0.05)",
    borderRadius: 10,
    paddingTop: 16,
    color: theme.colors.text.default
  },
  commentText: {
    color: "#DEE7E7",
    fontSize: 16,
    fontWeight: "500",
    marginBottom: 4,
    paddingTop: 8,
    paddingBottom: 8,
  },
  dateText: {
    fontSize: 14,
    marginBottom: 8,
    color: theme.colors.text.caption,
  },
  emotionContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",

  },
  emoji: {
    fontSize: 20,
    marginRight: 6,
  },
  emotionText: {
    color: theme.colors.text.caption,
    fontSize: 16,
  },
  icon: {
    marginRight: 8,
    alignItems: 'center',
    justifyContent: 'center',
  },
  iconWrapper: {
    marginRight: 8,
    justifyContent: "center",
    alignItems: "center",
  },  
  separator: {
    marginTop: 8,
    marginBottom: 8,
    border: "1px solid #DEE7E736",
    width: "100%",
  },
  captionText: {
    color: theme.colors.text.caption,
    fontSize: 14,
  },
  indicatorsContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  }
};

export default styles;
